import React from 'react';

const EBookSearchOne = (props) => {

    return (

        <div className={`edu-blog-widget${props.style2 === 'active' ? '-2' : ''} widget-search ${props.extraClass || ''}`}>

            <div className="inner">
                <h5 className="widget-title ">Search Here</h5>
                <div className="content">
                    <form className="blog-search" action="#">
                        <input type="text" value={props.inputText} placeholder="Search your Keyword..." onChange={props.handleEBookSearch} />
                        <button disabled className="search-button"><i className="icon-search-line"></i></button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EBookSearchOne;